module.exports = __webpack_public_path__ + "img/home2.15d205c9.jpg";